import { checkErrorData } from "./utils";
import { formatData } from "./utils";

export function fetchShops(){
    console.log("FIRED ACTION FETCH SHOPS" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_SHOPS_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"shops",
                }),
                credentials: 'same-origin',
            }); 
            
            const res = await response.json()
            console.log(res)

            if(!res.error){ // no errors
                
                dispatch(getShops(formatData(res.reverse()) ))
                dispatch({ type: "FETCH_SHOPS_FULFILLED", payload:"" })
                console.log(" shops fetched")
                            
            } else {
                dispatch({
                    type: "FETCH_SHOPS_ERROR",
                    payload: res.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_SHOPS_ERROR",
                payload: err
                
            })
        }
    }
}

export function createShop(newShop){
    // console.log("FIRED ACTION CREATE LOCATION", newShop)
    return async function(dispatch){
        dispatch({
            type: "CREATE_SHOP_START",
            payload: ""
            
        })
        try{
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"shops",
                    data:newShop
                }),
                credentials: 'same-origin',
            }); 
            
            const createdShop = await response.json()
            console.log({createdShop})// createdShop returns new object created
            if(createdShop.id){
                dispatch({
                    type: "NEW_SHOP",
                    payload: createdShop
                    
                })
                dispatch({ type: "CREATE_SHOP_FULFILLED", payload:"" })
                console.log("Shop created")
            } else {
                dispatch({
                    type: "CREATE_SHOP_ERROR",
                    payload: createdShop.error.message
                    
                })
                // this.setState({
                //     sending: false,
                //     notif:{
                //         title:"Erreur", 
                //         type:"danger", 
                //         message:createdShop.message,
                //         display:"fadeInDown"
                //     },
                // })
            }
            
        } catch(err){
            console.log("[ERROR] SUBMIT SHOPS ", err);
            dispatch({
                type: "CREATE_SHOP_ERROR",
                payload: err
                
            })
            // this.setState({
            //     sending: false,
            //     notif:{
            //         title:"Erreur", 
            //         type:"danger", 
            //         message:"Un problème est survenu",
            //         display:"fadeInDown"
            //     },
            // })
        }
        
    }
}
export function updateShop(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_SHOP_START", payload: "" })

            console.log("update Shop START")
            const response = await fetch('/stocks/shops/update',{
                method:'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedShop = await response.json()
            
            console.log({updatedShop});

            if(checkErrorData(updatedShop, "UPDATE_SHOP_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_SHOP",
                    payload: data
                })
                dispatch({ type: "UPDATE_SHOP_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update shop ", err);
            dispatch({
                type: "UPDATE_SHOP_ERROR",
                payload: err
                
            })
        }
    }
}

export function updateShopLogo(files)  {
	return async dispatch => new Promise(async function(resolve, reject) {
        try{
            const response = await fetch('/stocks/shops/update/generics',{
                method:'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    page:"shops/files/update",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedShop = await response.json()
            
            if (updatedShop.error){
                console.error("[updateShopLogo] Error:", updatedShop.error);
                reject(updatedShop.error) 
                return
            }
            
            // Update Redux store with the updated shop data
            dispatch({
                type: "UPDATE_SHOP",
                payload: updatedShop
            });
            
            resolve(updatedShop);

        } catch(err) {
            console.error("[updateShopLogo] Error:", err);
            reject(err);
        }
    })
}

export function getShops(shops){
    // console.log("FIRED ACTION GET LOCATION", shops)
    return {
        type: "GET_SHOPS",
        payload: shops
        
    }
}
export function setLogo(shopID,logoSRC){
    // console.log("FIRED ACTION GET LOCATION", shops)
    return {
        type: "SET_LOGO",
        payload: {shopID, logoSRC}
        
    }
}

export function getPhotoShop(shopID,file) {
    return async function(dispatch){        
        let response = await fetch("/stocks/getPhotos",{
            method:'POST',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body:JSON.stringify({
                path:file
            }),
            credentials: 'same-origin',
        })
        let image = await response.json()
        dispatch(setLogo(shopID, image.uri))
    }
}
export function fetchShopDetails(id){
    console.log("FIRED ACTION FETCH SHOP" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_SHOP_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    page:"shops",
                    id,
                }),
                credentials: 'same-origin',
            }); 
            
            const shop = await response.json()
            console.log(shop)// shop returns new object created

            if(!shop.error){ // no errors, return new Object         
                console.log('==============fetchShopDetails======================');
                console.log({shop});
                console.log('====================================');    
                return shop
            } else {
                dispatch({
                    type: "FETCH_SHOP_ERROR",
                    payload: shop.error.message
                })
                return {}
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_SHOP_ERROR",
                payload: err
            })
        }
    }
}